import {Injectable, OnInit} from '@angular/core';
import {Subject} from "rxjs";
import {EventManagerService} from "@wms/app";
import {assignIn, extend, set} from "lodash-es";
import {PageDetails, WS} from "@wms/page-workspace";
import { FileWorkspaceComponent } from "@wms/app/workspace";
import {FileWorkspaceService} from "@wms/app/file-workspace.service";

interface ResourceType {
  absPath: string;
  allowDelete: boolean;
  allowEdit: boolean;
  name: string;
  path: string;
  relativePath: string;
  type: string;
  fileRef?: any;
}

const SETTINGS_TABS = ['Security', 'General', 'Profile Configuration', 'Artifacts', 'Prefab Configuration', 'Build Preferences'];
const STYLE_TABS = ['Foundation', 'Widgets'];

@Injectable({
  providedIn: 'root'
})
export class WmsWorkspaceManagerService implements OnInit {
  saveWsEvent = new Subject();
  activeWsChangeEvent = new Subject();
  activeWSCategory: string = '';
  activeWS: any;
  isDirty: boolean = false;
  keyEvent: boolean = false;
  private wsCategories: any = [];
  private fileRef: FileWorkspaceComponent;
  private fieleWorkspaceService: FileWorkspaceService;
  public saveActiveWs: Subject<any> = new Subject<any>();
  public byPassUnLoadCheck:boolean;
  public triggerSaveImmediately: boolean;
  isAIStudioLoaded:boolean = false;
  isMessageServiceReady:boolean = false;
  serviceClassesMetaData: any;
  settingsActiveWsCateory:any;

  constructor(private eventManager: EventManagerService) {
    window.addEventListener('beforeunload', this.onBeforeUnload.bind(this));
    this.saveActiveWs.asObservable().subscribe((successCb: Function) => {
      let callback = () => {
        successCb();
        this.keyEvent = false;
        this.triggerSaveImmediately = false;
      }
      if (!this.isWSDirty()) {
        callback();
        return;
      }
      if (this.activeWSCategory === 'PAGE') {
        this.eventManager.emitSavePageWorkspace(callback);
      } else if (this.activeWSCategory === 'JAVASERVICE') {
        this.eventManager.emitJavaserviceSave(callback);
      } else if (this.activeWSCategory === 'RESOURCE') {
        this.eventManager.emitSaveFileWorkspace(callback);
      } else if (this.activeWSCategory === 'SETTINGS' || SETTINGS_TABS.includes(this.activeWSCategory)) {
        this.eventManager.emitSaveSettingWS(callback);
      } else if (this.activeWSCategory === 'APISERVICE') {
        this.eventManager.emitSaveApiWS(callback);
      } else {
        callback();
      }
    });
  }

  ngOnInit() {
  }

  setIsAIStudioLoaded(value:boolean) {
    this.isAIStudioLoaded = value;
  }

  setMessageServiceReady(value:boolean) {
    this.isMessageServiceReady = value;
  }

  getActiveWSCategory() {
    if (SETTINGS_TABS.includes(this.activeWSCategory)) {
      return 'SETTINGS';
    }
    if (STYLE_TABS.includes(this.activeWSCategory)) {
      return 'STYLE';
    }
    return this.activeWSCategory;
  }

  setActiveWSCategory(val: string) {
    this.activeWSCategory = val;
    this.eventManager.emitSetActiveWSCategory(val);
  }

  setWsCategories(wsCategories: any) {
    this.wsCategories = wsCategories;
  }

  setFileRef(self: FileWorkspaceComponent) {
    this.fileRef = self;
  }

  getFileRef(){
    return this.fileRef;
  }

  setServiceClassesMetaData(serviceClassesMetadata: any) {
    this.serviceClassesMetaData = serviceClassesMetadata;
  }

  setActiveWS(ws: any, forceLoad?: boolean) {
    if (!ws || !this.wsCategories.length) {
      return;
    }
    let category = ws._category || ws.type;
    if (!forceLoad && this.activeWS && ws.name === this.activeWS.name && (ws.type === this.activeWS.type || ws._category === this.activeWS._category)) {
      if (category === 'RESOURCE') {
        if (this.activeWS.path === ws.path) {
          return;
        }
      } else {
        return
      }
    }

    if (ws.type === 'RESOURCE' || ws._category === 'RESOURCE') {
      this.setResource(ws);
    }else if (ws.type === 'DB' || ws._category === 'DB') {
      this.setDB(ws)
    }

    if (category) {
      const details = this.wsCategories.find((c: any) => c.id === category.toUpperCase());
      if (!ws['details']) {
        ws['details'] = details;
      } else {
        ws['details'] = assignIn({}, details, ws['details']);
      }
    }

    this.activeWS = ws;
    this.activeWsChangeEvent.next(this.activeWS);
    this.setActiveWSCategory(category)
  }

  setResource(resource: ResourceType) {
    set(resource, '_category', 'RESOURCE');
    if (this.fileRef) {
      set(resource, 'isDirty', () => this.fieleWorkspaceService.resourceModified);
    }
    this.eventManager.emitRouteHistoryChange(resource);
  }

  setDB(dbDetails:any){
    set(dbDetails, '_category', 'DB');
    this.eventManager.emitRouteHistoryChange(dbDetails);
  }

  getActiveWS(){
    return this.activeWS;
  }

  updateWSDetails(ws: WS, details?: PageDetails) {
    if (details) {
      extend(ws.details, details);
    }
    this.setActiveWS(ws, true);
  }

  isWSDirty() {
    return (this.activeWS && this.activeWS.isWSDirty) ? this.activeWS.isWSDirty() : this.isDirty;
  }

  setDirtyonWs(flag: boolean) {
    this.isDirty = flag;
  }

private onBeforeUnload(event: BeforeUnloadEvent): void {
  if (this.activeWS && this.isDirty && !this.byPassUnLoadCheck) {
    event.returnValue = "Please note, there are unsaved changes in the project which will be lost.";
  }
}

}
